import { render } from "./GenderInput.vue?vue&type=template&id=1fe124c8&scoped=true"
import script from "./GenderInput.vue?vue&type=script&lang=js"
export * from "./GenderInput.vue?vue&type=script&lang=js"

import "./GenderInput.vue?vue&type=style&index=0&id=1fe124c8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe124c8"]])

export default __exports__